<template>
<el-tabs class="tab-button" v-model="activeTabName" @tab-click="changeActiveTab">
  <!-- 프로세스 -->
  <el-tab-pane v-if="!operationFlag" :label="tabs.process.label" :name="tabs.process.name" :key="tabs.process.name">
    <w-process-table :ref="tabs.process.name" :operation-flag="operationFlag" :active="tabs.process.active" />
  </el-tab-pane>
  <!-- 프로세스 [운영 탭 진입] -->
  <el-tab-pane v-if="operationFlag" :label="tabs.process.label" :name="tabs.process.name" :key="tabs.process.name">
    <w-server-realtime-control-component :ref="tabs.process.name" :operation-flag="operationFlag" :active="tabs.process.active" />
  </el-tab-pane>
  <!-- TCP/UDP 포트  -->
  <el-tab-pane :label="tabs.port.label" :name="tabs.port.name" :key="tabs.port.name">
    <w-tcp-udp-port-table :ref="tabs.port.name" :operation-flag="operationFlag" :active="tabs.port.active" />
  </el-tab-pane>
  <!-- 세션 -->
  <el-tab-pane :label="tabs.session.label" :name="tabs.session.name" :key="tabs.session.name">
    <w-session-table :ref="tabs.session.name" :operation-flag="operationFlag" :active="tabs.session.active" />
  </el-tab-pane>
  <!-- 시스템 접근 -->
  <el-tab-pane :label="tabs.systemAccess.label" :name="tabs.systemAccess.name" :key="tabs.systemAccess.name">
    <w-system-access-info-table :ref="tabs.systemAccess.name" :operation-flag="operationFlag" :active="tabs.systemAccess.active" />
  </el-tab-pane>
  <!-- 어플리케이션 로그 -->
  <el-tab-pane :label="tabs.appLog.label" :name="tabs.appLog.name" :key="tabs.appLog.name">
    <w-app-log-table :ref="tabs.appLog.name" :operation-flag="operationFlag" :active="tabs.appLog.active" />
  </el-tab-pane>
  <!-- 파일 정보 - 개선건 요청으로 구성 탭으로부터 이동 -->
  <el-tab-pane v-if="operationFlag" :label="tabs.fileInfo.label" :name="tabs.fileInfo.name" :key="tabs.fileInfo.name">
    <w-file-info-node :ref="tabs.fileInfo.name" :operation-flag="operationFlag" :active="tabs.fileInfo.active" :nodeParams="serverParams" />
  </el-tab-pane>
</el-tabs>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import WServerRealtimeControlComponent from '@/views/performance/node/operation/server/components/ServerRealtimeControlComponent';
import WFileInfoNode from '@/views/performance/node/operation/server/components/FileInfoComponent';
import WProcessTable from './components/table/ProcessTable';
import WTcpUdpPortTable from './components/table/TcpUdpPortTable';
import WSessionTable from './components/table/SessionTable';
import WSystemAccessInfoTable from './components/table/SystemAccessInfoTable';
import WAppLogTable from './components/table/AppLogTable';

export default {
  name: 'WPerformanceNetdeviceAnalysisTable',
  components: {
    WProcessTable,
    WTcpUdpPortTable,
    WSessionTable,
    WSystemAccessInfoTable,
    WAppLogTable,
    WServerRealtimeControlComponent,
    WFileInfoNode,
  },
  props: {
    operationFlag: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      serverParams: {},
      activeTabName: '',
      activeTab: null,
      tabs: {
        process: {
          name: 'process',
          label: '프로세스',
          active: false,
        },
        port: {
          name: 'port',
          label: 'TCP/UDP 포트',
          active: false,
        },
        session: {
          name: 'session',
          label: '세션',
          active: false,
        },
        systemAccess: {
          name: 'systemAccess',
          label: '시스템 접근',
          active: false,
        },
        appLog: {
          name: 'appLog',
          label: '어플리케이션 로그',
          active: false,
        },
        fileInfo: {
          name: 'fileInfo',
          label: '파일 정보',
          active: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    // [운영 탭] 기존 분석탭은 차트에서 loadData 하는 구조였기에 운영탭에서는 아래와 같이 ref를 이용하여 직접 loadData한다.
    selectedNode: {
      handler(node) {
        if (node.obj && this.operationFlag) {
          this.$refs[this.activeTab.name].loadData();
        }
      },
    },
    active: {
      handler(flag) {
        if (flag && this.operationFlag) {
          this.$refs[this.activeTab.name].loadData();
        }
      },
    },
  },
  mounted() {
    this.activeTabName = this.tabs.process.name;
    this.changeActiveTab();
  },
  methods: {
    changeActiveTab() {
      const activeTab = this.tabs[this.activeTabName];
      activeTab.active = true;
      if (!isNil(this.activeTab)) {
        this.activeTab.active = false;
      }
      this.activeTab = activeTab;

      // 운영 탭에서 하위 탭들 loadData 수행
      if (this.operationFlag && this.active) {
        this.$nextTick(() => {
          this.$refs[activeTab.name].loadData();
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/PerformanceServerAnalysisTable.vue